import React, { useMemo } from "react";
import { useState } from "react";
import { GoogleMap, MarkerF, InfoWindowF } from "@react-google-maps/api";

const MapView = ({ markers = [], handleViewDetails }) => {
  const [selectedMarker, setSelectedMarker] = React.useState(null);

  // Automatically set the center to the first marker if available
  const center = useMemo(
    () => ({ lat: 30.76, lng: 76.71 }),
    [markers]
  );

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "500px", borderRadius: "16px" }}
      center={center}
      zoom={12}
    >
      {markers.map((marker) => (
        <MarkerF
          key={marker._id}
          position={{ lat: marker.latitude, lng: marker.longitude }}
          onClick={() => handleViewDetails(marker)}
          //onMouseOver={() => setSelectedMarker(marker)}
        // icon={{
        //   url: marker.icon || "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
        //   scaledSize: new window.google.maps.Size(40, 40),
        // }}
        />
      ))}

      {selectedMarker && (
        <InfoWindowF
          position={{ lat: selectedMarker.latitude, lng: selectedMarker.longitude }}
        >
          <div>
            <h4>{selectedMarker.title}</h4>
            <p>{selectedMarker.description}</p>
          </div>
        </InfoWindowF>
      )}

    </GoogleMap>
  );
};

export default MapView;
